import { DUMMY_PHONES_LIST } from "@/Constants";
import { authenticateUser, saveStaffMemberDetails, setPageLoaderVisibility } from "../Redux/Actions";
import store from "../Redux/Store";
import { getAuthToken } from "./authToken";
import history from "./history";
import LocalStorageHelper from "./LocalStorageHelper";
import { LOGIN_PAGE } from "@/Constants/routesConstant";

export const authenticate = (): Promise<any> => {
  return new Promise((resolve) => {
    const token = getAuthToken();
    store.dispatch(authenticateUser(token, history, (storeData: any) => resolve(storeData)));
  });
};

export const isDummyPhoneNumber = (phoneNumber: string) => {
  return DUMMY_PHONES_LIST.includes(phoneNumber);
};

export function onLogoutBtnClick(): void {
  store.dispatch(setPageLoaderVisibility(true));
  store.dispatch(saveStaffMemberDetails({}));
  setTimeout(() => {
    store.dispatch(setPageLoaderVisibility(false));
    LocalStorageHelper.clear();
    history.push(LOGIN_PAGE);
  }, 1000);
}
